import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import isAvailableRawProductVariantUtil from 'modules/product-variant/utils/is-available-raw'

/**
 * @param {ProductVariantCollection} productVariant
 * @return {number}
 */
const isAvailableProductVariantUtil = (productVariant) => {
  return (
    isAvailableRawProductVariantUtil(productVariant) ||
    getVariantsProductVariantUtil(productVariant).some(variant => variant.available)
  )
}

export default isAvailableProductVariantUtil
